import * as React from 'react'

import { Avatar, Box, Icon, IconBadge } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'

import buildUrl from 'modules/core/lib/buildUrl'

import type { AvatarUser, InboxRequest } from 'modules/notifications/hooks/useNotificationsRequests'

type BadgeProps = {
  request: InboxRequest
  icon?: React.ComponentProps<typeof Icon.Medium>['icon']
  avatarUsersMap?: Map<number, AvatarUser>
}

export const Badge = ({ request, icon, avatarUsersMap }: BadgeProps) => {
  const accessId = request.avatarAccessIdentifier
  const avatarUser = accessId ? avatarUsersMap?.get(accessId) : undefined

  return (
    <Box>
      {isNil(avatarUser) ? (
        <IconBadge
          color="viridian200"
          iconColor="viridian1200"
          size="s32"
          icon={
            (icon || request.icon || 'calendar') as React.ComponentProps<typeof Icon.Medium>['icon']
          }
        />
      ) : (
        <Avatar size="s32" url={buildUrl(avatarUser.avatar?.url)} label={avatarUser.fullName} />
      )}
    </Box>
  )
}
